module.exports = __webpack_public_path__ + "img/2D.1451de5d.png";